import { initFeaturedCaseStudiesCarousel } from "../component/featured-case-studies-carousel.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initSlimSelects } from "../component/custom-select.js";
import { portfolioLoadMore } from "../component/portfolio-load-more.js";
import { initCookieBar,initGooglePreferredSource,initDmcabadge } from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initGlowWrapper } from "../component/glow.js";

initContextMenu();
initCookieBar();
initDmcabadge();
initGooglePreferredSource();
initFeaturedCaseStudiesCarousel();
initOfficeHoverReveal();
initSlimSelects();
portfolioLoadMore();
initMobileMenu();

document.addEventListener("DOMContentLoaded", () => {
    initGlowWrapper();
});
